import { useQuery } from "@tanstack/react-query";
import { DefaultFilter } from "../../../../@types/filter";
import { AttendanceLocalGuiche } from "../../../../@types/attendance-local-guiche";
import { Paginated } from "../../../../@types/paginated";
import { apisiseci } from "../../../api";
import { useDefaultSearchParams } from "../../../../hooks/useSearchParams";
import { AxiosError } from "axios";

type Props = DefaultFilter & {
  unidade_slug?: string;
};

export function useAttendanceLocalGuicheList(params?: Props) {
  const token = localStorage.getItem("gov_access_token_sso");
  const defaultParams = useDefaultSearchParams();
  params = { ...defaultParams, ...params };

  return useQuery<Paginated<AttendanceLocalGuiche>, AxiosError<{ detail: string }>>({
    enabled: !!token,
    queryKey: ['attendance-local', 'guiche', 'list', params],
    queryFn: async () => {
      const response = await apisiseci.get<Paginated<AttendanceLocalGuiche>>(
        "/cms/guiche_unidade/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params,
        }
      );
      return response.data;
    },
  });
}
